import {Phone, IDP, Channel} from '@/ginkgo-grpc/jslang/proto/messages/common_pb'
import {UserProfile} from '@/ginkgo-grpc/jslang/proto/messages/user_pb'
import {ElMessage} from 'element-plus'
import { OSSFile, Input, Runner, Row, Column, TimeRange, OSSSource } from '@/ginkgo-grpc/jslang/proto/services/rbf_service_pb'
import {StringValue, UInt32Value, Int32Value} from 'google-protobuf/google/protobuf/wrappers_pb'
//"http://localhost:8080"//
const clientHost = process.env.VUE_APP_API as string

function getToken() {
  const token = localStorage.getItem('token')
  const header = { Authorization: 'Bearer ' + token } 
  return header
}

export function getUserId() {
  const userId = localStorage.getItem('userId') as string
  return userId
}

export const errorMessageMap = new Map([
  [
    'ErrTransferButPermissionDenied',
    'This account does not have transfer permission'
  ],
  ['ErrCaptchaInvalid', 'Verification code input error, please re-enter.'],
  ['ErrInvalidIDPCode', 'Verification code invalid, please re-enter.'],
  ['ErrUserInactivated', 'User not activated'],
  ['ErrPermissionDenied', 'No permission, please contact the administrator'],
  ['ErrInvalidRequestParams', 'Request parameter error'],
  ['ErrInvalidGithubUrl', 'Illegal githurl'],
  ['ErrProjectIncompleteData', 'Project data missing'],
  ['ErrUpdateProjectGithubUrlNeedFrok', 'The URL you entered needs Our fork'],
  ['ErrUpdateProjectGithubUrlNeedChip', 'Missing chip'],
  ['ErrProjectRunNeedChipAndGithubUrl', 'Chip and URL are required'],
  ['ErrUserIdFromTokenInvalid', 'Illegal token'],
  [
    'ErrCreateRunButProjectHasRunningFlow',
    'A project can only be run once at a time.'
  ],
  ['ErrTokenExpired', 'The token has expired, Please log in again'],
  ['ErrUserNotFound', 'User not found'],
])

function getErrorId(message: string) {
  if (message.includes('errorId:')) {
    const errorId = message.split('errorId:').pop();
    if (errorId) {
      //|| errorId == "ErrUserNotFound"
      if (errorId == "ErrUserIdFromTokenInvalid" || errorId == "ErrTokenExpired" || errorId == "ErrTokenMissing" || errorId == "ErrTokenInvalid") {
        localStorage.setItem('token', "")
        location.href = "/"
      }
      if (errorMessageMap.get(errorId) || errorId == "ErrUserNotFound") {
        ElMessage.error(errorMessageMap.get(errorId))
      }
    }
  } 
}


/** ali-oss*/
import OSS from 'ali-oss'
import {AliyunSTSServiceClient} from '@/ginkgo-grpc/jslang/proto/services/Ali_sts_serviceServiceClientPb'
import {GetAliyunSTSTokenRequest, GetAliyunSTSTokenResponse, GetOSSTokenRequest, GetOSSTokenResponse, OssRoleType} from '@/ginkgo-grpc/jslang/proto/services/ali_sts_service_pb'

function getOSSTokenRequest(
  client: AliyunSTSServiceClient, request: GetOSSTokenRequest) {
return new Promise((resolve, reject) => {
  try {
    client.getOSSToken(
        request, getToken(),
        function(err, data) {
          if (err) {
            console.error(err);
            reject(err)
          } else {
            resolve(data);
          }
        });
  } catch (e) {
    console.error(e)
    reject(e);
  }
})
}


export async function getOSSToken() {
const client = new AliyunSTSServiceClient(clientHost)
const request = new GetOSSTokenRequest()
request.setRole(OssRoleType.RBF)
const data = (await getOSSTokenRequest(client, request))
const obj = (data as GetOSSTokenResponse).toObject()

return obj
}

export async function getFileSize(bucket: string, name: string) {
  const data = await getOSSToken()
  const accessKeyId = data.accesskeyid
  const accessKeySecret = data.accesskeysecret
  const stsToken = data.securitytoken
  const endPoint = data.endpoint
  const region = data.region
  const client = new OSS({
    region: region,
    accessKeyId: accessKeyId,
    accessKeySecret: accessKeySecret,
    stsToken: stsToken,
    bucket: bucket,
    endpoint: endPoint
  })
  console.log("name = ", name);
  const result = await client.head(name)
  const headers = result.res.headers as any
  const size = headers["content-length"]
  // console.log("headers ==== ", headers["content-length"])
  return parseInt(size)
}

export async function getTrialFileLogs(bucket: string, path: string, from: number, to: number) {
  const data = await getOSSToken()
  const accessKeyId = data.accesskeyid
  const accessKeySecret = data.accesskeysecret
  const stsToken = data.securitytoken
  const endPoint = data.endpoint
  const region = data.region
  const client = new OSS({
    region: region,
    accessKeyId: accessKeyId,
    accessKeySecret: accessKeySecret,
    stsToken: stsToken,
    bucket: bucket,
    endpoint: endPoint
  })
  let logs = []
  try {
    const result = await client.get(path, { headers: { Range: `bytes=${from}-${to}`,}})
    const logStr = result.content.toString()
    if (logStr.length > 0) {
      logs = result.content.toString().split("\n")
    }
    return logs
  } catch (error) {
    // console.error(error)
    return logs
  }
}


export async function getNewOSSUrl(bucket: string, path: string, fileName: string) {
  const data = await getOSSToken()
  const accessKeyId = data.accesskeyid
  const accessKeySecret = data.accesskeysecret
  const stsToken = data.securitytoken
  const endPoint = data.endpoint
  const region = data.region
  const client = new OSS({
    region: region,
    accessKeyId: accessKeyId,
    accessKeySecret: accessKeySecret,
    stsToken: stsToken,
    bucket: bucket,
    endpoint: endPoint
  })

    const response = {
      'content-disposition':
          `attachment; filename=${encodeURIComponent(fileName)}`
    } 

    const url = client.signatureUrl(path, {response})
    return url

}
export async function downLoadFile(bucket: string, path: string) {
  const data = await getAliOSS()
  const accessKeyId = data.accesskeyid
  const accessKeySecret = data.accesskeysecret
  const stsToken = data.securitytoken
  const client = new OSS({
    region: 'cn-shanghai',
    accessKeyId: accessKeyId,
    accessKeySecret: accessKeySecret,
    stsToken: stsToken,
    bucket: bucket,
    endpoint: 'https://oss-cn-shanghai.aliyuncs.com'
  })
  // console.log("data = ", data);
  //test/coverage_result.tar.gz
  // https://oss-cn-shanghai.aliyuncs.com/Eden/401/139/workflow-result.json
  //https://icb-devops.oss-cn-shanghai.aliyuncs.com/Eden/401/139/workflow-result.json?OSSAccessKeyId=STS.NUZbeCC9rESfkDaQXzGksjb2S&Expires=2022-07-06T03:45:29Z&Signature=2E27WVbnCpAYEbBmBARu9HQfAGDBoBV5HjXCCLmvcMBS&security-token=CAIS6QF1q6Ft5B2yfSjIr5bvKd/3ruZT8pGNaWLQtVgvS+RfhaeZsTz2IHFMdHZsCekav/g0mmhX7/8SlqxvVptEXRRwy1CUG8wFnzm6aq/t5uaXj9Vd+rDHdEGXDxnkprywB8zyUNLafNq0dlnAjVUd6LDmdDKkLTfHWN/z/vwBVNkMWRSiZjdrHcpfIhAYyPUXLnzML/2gQHWI6yjydBM051Ig0z8iufnknZPNu0Dk4QekmrNPlePYOYO5asRgBpB7Xuqu0fZ+Hqi7i38Iu0cWpP4q3fAfp2+Y54jNGTRN/hGHK/pcMwjWsIPYDBqAAYlMzoUDtZaU5ve+ki7R5LE75UgjlxSeaObQd/P4cPHGfqGuo8cc1hmN2gV7cTCZ+HHgHHGP1pe+RJTb3Nr73v+N9ZFofIYhzpJnjFxMJ5vAfdUxK34WSyFcWHJ0fEGR+T3yI10GEZ2rY/MGT5Y+QkdJJGxxVP6BGHc79B8haxwW
  try {
    const result = await client.get(path);
    return result.content
  } catch (error) {
    console.error(error)
  }
  

  // const file = "Eden/401/138/workflow-result.json"//path
  // const paths = file.split('/')
  // if (paths.length > 0) {
  //   const name = paths.pop()!
  //   const filename = name
  //   const response = {
  //     'content-disposition':
  //         `attachment; filename=${encodeURIComponent(filename)}`
  //   } 
  //   const url = client.signatureUrl(file, {response})
  //     console.log("url = ", url)
  //   return url
  // }

  // try {
  //   //query: OSS.ListObjectsQuery | null, options: OSS.RequestOptions
  //   //, delimiter: '/'
  //   //, prefix: "Eden/385/144/", delimiter: "/"
  //   const result = await client.list({"max-keys": 1000,  prefix: "Eden/"}, {timeout: 10000});
  //   return result
  // } catch (error) {
  //   console.error(error)
  // }
 
}

export async function getOSSUrl(bucket: string, path: string) {
  const data = await getAliOSS()
  const accessKeyId = data.accesskeyid
  const accessKeySecret = data.accesskeysecret
  const stsToken = data.securitytoken
  const client = new OSS({
    region: 'cn-shanghai',
    accessKeyId: accessKeyId,
    accessKeySecret: accessKeySecret,
    stsToken: stsToken,
    bucket: bucket,
    endpoint: 'https://oss-cn-shanghai.aliyuncs.com'
  })

  const file = path
  const paths = file.split('/')
  if (paths.length > 0) {
    const name = paths.pop()!
    const filename = name
    const response = {
      'content-disposition':
          `attachment; filename=${encodeURIComponent(filename)}`
    } 

  //, {response}
    const url = client.signatureUrl(file, {response})
    return url
  }
}


export async function getOSSFileList(bucket: string, path: string) {

  const data = await getAliOSS()
  const accessKeyId = data.accesskeyid
  const accessKeySecret = data.accesskeysecret
  const stsToken = data.securitytoken
  const client = new OSS({
    region: 'cn-shanghai',
    accessKeyId: accessKeyId,
    accessKeySecret: accessKeySecret,
    stsToken: stsToken,
    bucket: bucket,
    endpoint: 'https://oss-cn-shanghai.aliyuncs.com'
  })

  try {
    //query: OSS.ListObjectsQuery | null, options: OSS.RequestOptions
    //, delimiter: '/'
    //, prefix: "Eden/385/144/", delimiter: "/"
    const result = await client.list({"max-keys": 1000,  prefix: path}, {timeout: 10000});
    return result
  } catch (error) {
    console.error(error)
  }

}


export async function getAliOSS() {
  const client = new AliyunSTSServiceClient(clientHost)
  const request = new GetAliyunSTSTokenRequest()
  request.setRole('tulip')
  const data = (await getAliOssRequest(client, request))
  const credentials = (data as GetAliyunSTSTokenResponse).toObject().credentials!
  return credentials
}

function getAliOssRequest(
  client: AliyunSTSServiceClient, request: GetAliyunSTSTokenRequest) {
return new Promise((resolve, reject) => {
  try {
    client.getAliyunSTSToken(
        request, getToken(),
        function(err, data) {
          if (err) {
            console.error(err);
            reject(err)
          } else {
            resolve(data);
          }
        });
  } catch (e) {
    console.error(e)
    reject(e);
  }
})
}

export async function getTulipOSSToken() {
  const client = new AliyunSTSServiceClient(clientHost)
  const request = new GetOSSTokenRequest()
  request.setRole(OssRoleType.TULIP)
  const data = (await getOSSTokenRequest(client, request))
  const obj = (data as GetOSSTokenResponse).toObject()

  const accessKeyId = obj.accesskeyid
  const accessKeySecret = obj.accesskeysecret
  const stsToken = obj.securitytoken
  const bucket = obj.bucket
  const endPoint = obj.endpoint
  const region = obj.region
  console.log("obj = ", obj)
  const oss = new OSS({
    region: region,
    accessKeyId: accessKeyId,
    accessKeySecret: accessKeySecret,
    stsToken: stsToken,
    bucket: bucket,
    endpoint: endPoint
  })
  return oss
}


const partSize = 100 * 1024; // 每个分片大小(byte)
// 设置并发上传的分片数量。
const parallel = 3; 
export async function upLoadFile(fileName: string, file: any, back: (gress: number, point: any, client: any, succ: Boolean)=>void) {
  const client = await getTulipOSSToken() 
  console.log("client: ", client)
  let tempCheckpoint;
  try {
    const result = await client.multipartUpload(fileName, file, {
      parallel: parallel,
      partSize: partSize,
      progress: function (p: number, checkpoint: any) {
        // console.log(p, checkpoint)
        tempCheckpoint = checkpoint
        back(p, tempCheckpoint, client, true)
      },
    })
    console.log("result = ", result)
  } catch (err) {
    console.log(err)
    back(0, tempCheckpoint, client, false)
  }
}

export async function newDownLoadFile(ossKey: string, fileName: string) {
  console.log("ossKey == ", ossKey, " fileName == ", fileName)
  const client = await getTulipOSSToken()
  const file = ossKey
  const paths = file.split('/')
  if (paths.length > 0) {
    const name = paths.pop()!
    const filename = name
    const response = {
      'content-disposition':
          `attachment; filename=${encodeURIComponent(fileName)}`
    } 
    const url = client.signatureUrl(file, {response})
    console.log("url = ", url)
    return url
  }
}

/****************************************************************    创建验证码  *********************************/
import {CreateCaptchaRequest} from '@/ginkgo-grpc/jslang/proto/services/captcha_service_pb'
import {CaptchaServiceClient} from '@/ginkgo-grpc/jslang/proto/services/Captcha_serviceServiceClientPb'
function captchaRequest(client: CaptchaServiceClient, request: CreateCaptchaRequest) {
  return new Promise((resolve, reject) => {
    try {
      client.createCaptcha(request, null, function(err, data) {
        if (err) {
          console.error(err);
          reject(err)
          // getErrorId(err.message)
        } else {
          resolve(data);
        }
      });
    } catch (e) {
      console.error(e)
      reject(e);
    }
  })
}

export async function createCaptcha(phone: string, countryCode: string) {
  const client = new CaptchaServiceClient(clientHost)
  const request = new CreateCaptchaRequest()
  const phoneObj = new Phone()
  phoneObj.setCountrycode(countryCode)
  phoneObj.setPhone(phone)
  request.setPhone(phoneObj)
  request.setIslogin(true)
  request.setChannel(Channel.AQUA)
  console.log(request)
  const data = (await captchaRequest(client, request))
  return data
}

/****************************************************************    获取token ********************************/
import {AuthServiceClient} from '@/ginkgo-grpc/jslang/proto/services/Auth_serviceServiceClientPb'
import {CreateAuthRequest, CreateAuthResponse, CreateTransferTokenRequest, CreateTransferTokenResponse, LoginRequest, LoginResponse, SignupRequest, SignupResponse} from '@/ginkgo-grpc/jslang/proto/services/auth_service_pb'

function authRequest(client: AuthServiceClient, request: CreateAuthRequest) {
  return new Promise((resolve, reject) => {
    try {
      client.createAuthToken(request, getToken(), function(err, data) {
        if (err) {
          reject(err)
          getErrorId(err.message)
        } else {
          resolve(data);
        }
      });
    } catch (e) {
      console.error(e)
      reject(e);
    }
  })
}

export async function createAuth(phone: string, captcha: string, countryCode: string) {
  const client = new AuthServiceClient(clientHost)
  const request = new CreateAuthRequest()
  const phoneObj = new Phone()
  phoneObj.setCountrycode(countryCode)
  phoneObj.setPhone(phone)
  request.setPhone(phoneObj)
  request.setCaptcha(captcha)
  const data = (await authRequest(client, request))
  const respon = (data as CreateAuthResponse).toObject()
  const token = respon.token
  const userId = respon.userid
  if (token) {
    localStorage.setItem('token', token)
  }
  if (userId) {
    localStorage.setItem('userId', userId)
  }
}


/****************************************************************   User ********************************/
import {UserServiceClient} from '@/ginkgo-grpc/jslang/proto/services/User_serviceServiceClientPb'
import {CreateUserRequest, CreateUserResponse, GetUserByIdRequest, GetUserByIdResponse, GetManagedUsersPagingRequest, GetManagedUsersPagingResponse, PutUserRolesRequest, PutUserRolesResponse, PutUserStatusRequest, PutUserStatusResponse, PatchUserRequest, PatchUserResponse, CreateFeedbackRequest, CreateFeedbackResponse} from '@/ginkgo-grpc/jslang/proto/services/user_service_pb'

function loginRequest(client: AuthServiceClient, request: LoginRequest) {
  return new Promise((resolve, reject) => {
    try {
      client.login(request, null, function(err, data) {
        if (err) {
          console.error(err);
          reject(err)
          getErrorId(err.message)
        } else {
          resolve(data);
        }
      });
    } catch (e) {
      console.error(e)
      reject(e);
    }
  })
}

export async function login(code: string) {
  const client = new AuthServiceClient(clientHost )
  const request = new LoginRequest()
  const idp = IDP.ICBENCH
  request.setIdp(idp)
  request.setAuthcode(code)
  console.log(" request= ", request, "idp = ", idp)
  const data = (await loginRequest(client, request))
  const respon = (data as LoginResponse).toObject()
  console.log('respon = ', respon, data)
  const token = respon.token
  const userId = respon.userid
  if (token) {
    localStorage.setItem('token', token)
  }
  if (userId) {
    localStorage.setItem('userId', userId)
  }
  console.log('login token = ', token, "userId = ", userId)
  return respon
}


//**** patchUser
function patchUserRequest(
  client: UserServiceClient, request: PatchUserRequest) {
return new Promise((resolve, reject) => {
  try {
    client.patchUser(request, getToken(), function(err, data) {
      if (err) {
        console.error(err);
        reject(err)
        getErrorId(err.message)
      } else {
        resolve(data);
      }
    });
  } catch (e) {
    console.error(e)
    reject(e);
  }
})
}

export async function patchUser(item: any) {
  const client = new UserServiceClient(clientHost)
  const request = new PatchUserRequest()
  request.setNickname(item.name)
  request.setCompany(item.organization)
  request.setJobtitle(item.jobtitle)
  const phone = new Phone()
  phone.setPhone(item.phone)
  phone.setCountrycode(item.countryCode)
  request.setPhone(phone)
  const data = (await patchUserRequest(client, request))
  const response = (data as PatchUserResponse).toObject()
  console.log('response =', response)
  return response
}

//**** login
function userRequest(client: UserServiceClient, request: CreateUserRequest) {
  return new Promise((resolve, reject) => {
    try {
      client.createUser(request, getToken(), function(err, data) {
        if (err) {
          console.error(err);
          reject(err)
          getErrorId(err.message)
        } else {
          resolve(data);
        }
      });
    } catch (e) {
      console.error(e)
      reject(e);
    }
  })
}

export async function loginUser(phone: string, captcha: string, countryCode: string) {
  const client = new UserServiceClient(clientHost)
  const request = new CreateUserRequest()

  const phoneObj = new Phone()
  phoneObj.setCountrycode(countryCode)
  phoneObj.setPhone(phone)

  request.setPhone(phoneObj)
  request.setCaptcha(captcha)
  const data = (await userRequest(client, request))
  const response = (data as CreateUserResponse).toObject()
  return response
}

//****** getUserById
function getUserByIdRequest(client: UserServiceClient, request: GetUserByIdRequest) {
  return new Promise((resolve, reject) => {
    try {
      client.getUserById(request, getToken(), function(err, data) {
        if (err) {
          console.error(err);
          getErrorId(err.message)
          reject(err)
        } else {
          resolve(data);
        }
      });
    } catch (e) {
      console.error(e)
      reject(e);
    }
  })
}

export async function getUserById() {
  const client = new UserServiceClient(clientHost)
  const request = new GetUserByIdRequest()
  const userId = getUserId()
  request.setUserid(userId)
  const data = (await getUserByIdRequest(client, request))
  const response = (data as GetUserByIdResponse).toObject()
  return response
}


export async function getPageUserByUserId(userId: string) {
  const client = new UserServiceClient(clientHost)
  const request = new GetUserByIdRequest()
  request.setUserid(userId)
  const data = (await getUserByIdRequest(client, request))
  const response = (data as GetUserByIdResponse).toObject()
  return response
}



/****************************************************************   BenchMark ********************************/
import {BenchmarkServiceClient} from '@/ginkgo-grpc/jslang/proto/services/Benchmark_serviceServiceClientPb'
import {GetBenchmarksRequest, GetBenchmarksResponse} from '@/ginkgo-grpc/jslang/proto/services/benchmark_service_pb'

export async function getBenchMarks(model: any) {


  const client = new BenchmarkServiceClient(clientHost)
  const request = new GetBenchmarksRequest()
 
  if (model?.tool) {
    const toolStr = new StringValue().setValue(model.tool)
    request.setTool(toolStr)
  }
  // if (model?.release) {
  //   const releaseStr = new StringValue().setValue(model.release)
  //   request.setRelease(releaseStr)
  // }
  // if (model?.testcase) {
  //   const testcaseStr = new StringValue().setValue(model.testcase)
  //   request.setTestcase(testcaseStr)
  // }

  const response = await getBenchMarksRequest(client, request)
  const list = []
  const benchmarksList = (response as GetBenchmarksResponse).toObject().benchmarksList
  if (benchmarksList?.length > 0) {
    for (const item of benchmarksList) {
      if (item.id) {
        list.push(item)
      }
    }
  }
  return list

}


function getBenchMarksRequest(client: BenchmarkServiceClient, request: GetBenchmarksRequest) {
  return new Promise((resolve, reject) => {
    try {
      client.getBenchmarks(request, getToken(), function(err, data) {
        if (err) {
          console.error(err);
          reject(err)
          getErrorId(err.message)
        } else {
          resolve(data);
        }
      });
    } catch (e) {
      console.error(e)
      reject(e);
    }
  })
}

import {RBFServiceClient} from '@/ginkgo-grpc/jslang/proto/services/Rbf_serviceServiceClientPb'
import {QueryStatusRequest, QueryStatusResponse, QueryMetricsRequest, QueryMetricsResponse, ResourceType, UploadDataRequest, UploadDataResponse, BuildDataRequest, BuildDataResponse, MarkPublishRequest, AddTagRequest} from '@/ginkgo-grpc/jslang/proto/services/rbf_service_pb'

export async function getQueryStatus(resourceId: string, type: ResourceType) {
  const client = new RBFServiceClient(clientHost)
  const request = new QueryStatusRequest()
  request.setResourceid(resourceId)
  request.setResourcetype(type)
  const response = await getQueryStatusRequest(client, request)
  const data = (response as QueryStatusResponse).toObject()
  return data
}

function getQueryStatusRequest(client: RBFServiceClient, request: QueryStatusRequest) {
  return new Promise((resolve, reject) => {
    try {
      client.queryStatus(request, getToken(), function(err, data) {
        if (err) {
          console.error(err);
          reject(err)
          getErrorId(err.message)
        } else {
          resolve(data);
        }
      });
    } catch (e) {
      console.error(e)
      reject(e);
    }
  })
}

export async function getQueryMetricsBySheet(sheetId: string, needMetrics: boolean = true) {
  const client = new RBFServiceClient(clientHost)
  const request = new QueryMetricsRequest()
  request.setSheetid(sheetId)
  request.setNeedmetrics(needMetrics)
  const response = await getQueryMetricsBySheetRequest(client, request)
  const list = (response as QueryMetricsResponse).toObject().trialmetricsList
  return list
}

function getQueryMetricsBySheetRequest(client: RBFServiceClient, request: QueryMetricsRequest) {
  return new Promise((resolve, reject) => {
    try {
      client.queryMetricsBySheet(request, getToken(), function(err, data) {
        if (err) {
          console.error(err);
          reject(err)
          getErrorId(err.message)
        } else {
          resolve(data);
        }
      });
    } catch (e) {
      console.error(e)
      reject(e);
    }
  })
}


export async function uploadData(file: any) {
  const client = new RBFServiceClient(clientHost)
  const request = new UploadDataRequest()
  const fileModel = new OSSFile()
  fileModel.setBucket(file.bucket)
  fileModel.setKey(file.key)
  fileModel.setOriginname(file.name)
  fileModel.setSha1(file.sha1)
  request.setOssfile(fileModel)
  const response = await getUploadDataRequest(client, request)
  const da = (response as UploadDataResponse).toObject()
  return da
}

function getUploadDataRequest(client: RBFServiceClient, request: UploadDataRequest) {
  return new Promise((resolve, reject) => {
    try {
      client.uploadData(request, getToken(), function(err, data) {
        if (err) {
          console.error(err);
          reject(err)
          getErrorId(err.message)
        } else {
          resolve(data);
        }
      });
    } catch (e) {
      console.error(e)
      reject(e);
    }
  })
}

export async function buildData(item: any) {
  const client = new RBFServiceClient(clientHost)
  const request = new BuildDataRequest()
  /*
  inputsList: Array<Input.AsObject>,
    runnersList: Array<Runner.AsObject>,
  */
  const inputsList = []
  const runnersList = []
  for (const m of item.inputsList) {
    const input = new Input()
    input.setDataid(m.dataId)
    input.setName(m.name)
    inputsList.push(input)
  }
  for (const m of item.runnersList) {
    const runner = new Runner()
    runner.setImage(m.image)
    runner.setResource(m.resource)
    runnersList.push(runner)
  }
  request.setInputsList(inputsList)
  request.setRunnersList(runnersList)
  const response = await getBuildDataRequest(client, request)
  const da = (response as BuildDataResponse).toObject().databuilderid
  return da
}

function getBuildDataRequest(client: RBFServiceClient, request: BuildDataRequest) {
  return new Promise((resolve, reject) => {
    try {
      client.buildData(request, getToken(), function(err, data) {
        if (err) {
          console.error(err);
          reject(err)
          getErrorId(err.message)
        } else {
          resolve(data);
        }
      });
    } catch (e) {
      console.error(e)
      reject(e);
    }
  })
}

import {SubmitTrialRequest, SubmitTrialResponse, CreateTrialSheetRequest, CreateTrialSheetResponse, UpdateTrialSheetRequest, UpdateAnnotationRequest, MarkLongLiveRequest, QueryResourceTypeRequest, QueryResourceTypeResponse, QueryResourcesListRequest, QueryResourcesListResponse, CancelTrialRequest, CancelTrialsBySheetRequest, CancelTrialsBySheetResponse } from '@/ginkgo-grpc/jslang/proto/services/rbf_service_pb'
import { forEach } from 'jszip'

export async function cancelTrial(trialId: string) {
  const client = new RBFServiceClient(clientHost)
  const request = new CancelTrialRequest()
  request.setTrialid(trialId)
  const response = await cancelTrialRequest(client, request)
  return response
}

function cancelTrialRequest(client: RBFServiceClient, request: CancelTrialRequest) {
  return new Promise((resolve, reject) => {
    try {
      client.cancelTrial(request, getToken(), function(err, data) {
        if (err) {
          console.error(err);
          reject(err)
          getErrorId(err.message)
        } else {
          resolve(data);
        }
      });
    } catch (e) {
      console.error(e)
      reject(e);
    }
  })
}

export async function cancelTrialsBySheet(sheetId: string) {
  const client = new RBFServiceClient(clientHost)
  const request = new CancelTrialsBySheetRequest()
  request.setSheetid(sheetId)
  const response = await cancelTrialsBySheetRequest(client, request)
  const rowsList = (response as CancelTrialsBySheetResponse).toObject().rowsList
  return rowsList
}

function cancelTrialsBySheetRequest(client: RBFServiceClient, request: CancelTrialsBySheetRequest) {
  return new Promise((resolve, reject) => {
    try {
      client.cancelTrialsBySheet(request, getToken(), function(err, data) {
        if (err) {
          console.error(err);
          reject(err)
          getErrorId(err.message)
        } else {
          resolve(data);
        }
      });
    } catch (e) {
      console.error(e)
      reject(e);
    }
  })
}


export async function submitTrial(item: any) {
  const client = new RBFServiceClient(clientHost)
  const request = new SubmitTrialRequest()
  const inputsList = []
  const runnersList = []
  for (const m of item.inputsList) {
    const input = new Input()
    input.setDataid(m.dataId)
    input.setName(m.name)
    inputsList.push(input)
  }
  for (const m of item.runnersList) {
    const runner = new Runner()
    runner.setImage(m.image)
    runner.setResource(m.resource)
    runnersList.push(runner)
  }
  request.setInputsList(inputsList)
  request.setRunnersList(runnersList)
  request.setMachinesensitive(item.machinesensible)
  const response = await getSubmitTrialRequest(client, request)
  const da = (response as SubmitTrialResponse).toObject()
  return da
}

function getSubmitTrialRequest(client: RBFServiceClient, request: SubmitTrialRequest) {
  return new Promise((resolve, reject) => {
    try {
      client.submitTrial(request, getToken(), function(err, data) {
        if (err) {
          console.error(err);
          reject(err)
          getErrorId(err.message)
        } else {
          resolve(data);
        }
      });
    } catch (e) {
      console.error(e)
      reject(e);
    }
  })
}


export async function createTrialSheet(item: any) {
  const client = new RBFServiceClient(clientHost)
  const request = new CreateTrialSheetRequest()
  const rowsList = []
  const columnsList = []
  for (const m of item.rowsList) {
    const row = new Row()
    row.setName(m.name)
    row.setTrialid(m.trialId)
    rowsList.push(m)
  }
  for (const m of item.columnsList) {
    const column = new Column()
    column.setName(m.name)
    column.setField(m.field)
    column.setColor(m.color)
    column.setPerfermax(m.perfermax)
    columnsList.push(m)
  }
  request.setRowsList(rowsList)
  request.setColumnsList(columnsList)
  const response = await getCreateTrialSheetRequest(client, request)
  const da = (response as CreateTrialSheetResponse).toObject().sheetid
  return da
}

function getCreateTrialSheetRequest(client: RBFServiceClient, request: CreateTrialSheetRequest) {
  return new Promise((resolve, reject) => {
    try {
      client.createTrialSheet(request, getToken(), function(err, data) {
        if (err) {
          console.error(err);
          reject(err)
          getErrorId(err.message)
        } else {
          resolve(data);
        }
      });
    } catch (e) {
      console.error(e)
      reject(e);
    }
  })
}


export async function updateTrialSheet(item: any) {
  console.log("item = ", item)
  const client = new RBFServiceClient(clientHost)
  const request = new UpdateTrialSheetRequest()
  
  const rowsArr = []
  for (const model of item.rowsList) {
    const row1 = new Row()
    row1.setName(model.name)
    row1.setTrialid(model.trialid)
    rowsArr.push(row1)
  }
  console.log("rowsArr = ", rowsArr)

  const columnsArr = []
  for (const model of item.columnsList) {
    const column = new Column()
    column.setName(model.name)
    column.setField(model.field)
    column.setColor(model.color)
    column.setPerfermax(model.perfermax)
    columnsArr.push(column)
  }
  console.log("columnsArr = ", columnsArr)

  request.setSheetid(item.sheetId)
  request.setRowsList(rowsArr)
  request.setColumnsList(columnsArr)
  const response = await getUpdateTrialSheetRequest(client, request)
  console.log(response)
  return response
}

function getUpdateTrialSheetRequest(client: RBFServiceClient, request: UpdateTrialSheetRequest) {
  return new Promise((resolve, reject) => {
    try {
      client.updateTrialSheet(request, getToken(), function(err, data) {
        if (err) {
          console.error(err);
          reject(err)
          getErrorId(err.message)
        } else {
          resolve(data);
        }
      });
    } catch (e) {
      console.error(e)
      reject(e);
    }
  })
}


export async function updateAnnotation(item: any) {
  const client = new RBFServiceClient(clientHost)
  const request = new UpdateAnnotationRequest()
  request.setResourceid(item.resourceId)
  request.setResourcetype(item.type)
  const map = request.getAnnotationsMap()
  for (const model of item.list) {
    if (model.keyWord || model.keyWord) {
      map.set(model.keyWord.trim(), model.keyValue.trim())
    }
  }
  const response = await getUpdateAnnotationRequest(client, request)
  console.log("respons = ", response)
  return response
}

function getUpdateAnnotationRequest(client: RBFServiceClient, request: UpdateAnnotationRequest) {
  return new Promise((resolve, reject) => {
    try {
      client.updateAnnotation(request, getToken(), function(err, data) {
        if (err) {
          console.error(err);
          reject(err)
          getErrorId(err.message)
        } else {
          resolve(data);
        }
      });
    } catch (e) {
      console.error(e)
      reject(e);
    }
  })
}


export async function markLongLive(item: any) {
  const client = new RBFServiceClient(clientHost)
  const request = new MarkLongLiveRequest()
  request.setLonglive(item.longLive)
  request.setResourceid(item.resourceId)
  request.setResourcetype(item.type)
  const response = await getMarkLongLiveRequest(client, request)
  return response
}

function getMarkLongLiveRequest(client: RBFServiceClient, request: MarkLongLiveRequest) {
  return new Promise((resolve, reject) => {
    try {
      client.markLongLive(request, getToken(), function(err, data) {
        if (err) {
          console.error(err);
          reject(err)
          getErrorId(err.message)
        } else {
          resolve(data);
        }
      });
    } catch (e) {
      console.error(e)
      reject(e);
    }
  })
}

export async function markPublish(item: any) {
  const client = new RBFServiceClient(clientHost)
  const request = new MarkPublishRequest()
  request.setResourcetype(item.type)
  request.setPublish(item.publish)
  request.setResourceid(item.resourceId)
  const map = request.getAnnotationsMap()
  for (const model of item.list) {
    if (model.keyWord || model.keyValue) {
      map.set(model.keyWord, model.keyValue)
    }
  }
  const response = await markPublishRequest(client, request)
  return response
}

function markPublishRequest(client: RBFServiceClient, request: MarkPublishRequest) {
  return new Promise((resolve, reject) => {
    try {
      client.markPublish(request, getToken(), function(err, data) {
        if (err) {
          console.error(err);
          reject(err)
          getErrorId(err.message)
        } else {
          resolve(data);
        }
      });
    } catch (e) {
      console.error(e)
      reject(e);
    }
  })
}

export async function queryResourceType(resourceId: string) {
  const client = new RBFServiceClient(clientHost)
  const request = new QueryResourceTypeRequest()
  request.setResourceid(resourceId)
  const response = await getQueryResourceTypeRequest(client, request)
  const da = (response as QueryResourceTypeResponse).toObject().resourcetype
  return da
}

function getQueryResourceTypeRequest(client: RBFServiceClient, request: QueryResourceTypeRequest) {
  return new Promise((resolve, reject) => {
    try {
      client.queryResourceType(request, getToken(), function(err, data) {
        if (err) {
          console.error(err);
          reject(err)
          getErrorId(err.message)
        } else {
          resolve(data);
        }
      });
    } catch (e) {
      console.error(e)
      reject(e);
    }
  })
}

export async function queryResourcesList(model: any, isOwner: boolean = true) {
  const client = new RBFServiceClient(clientHost)
  const request = new QueryResourcesListRequest()
  request.setResourcetype(model.type)
  if (model?.tags?.length > 0) {
    request.setTagsList(model.tags)
  }
  request.setPagenumber(model?.pageNumber)
  request.setPagesize(model?.pageSize)
  request.setIsowner(isOwner)
  const timeRange = new TimeRange()
  if (model?.timeRange) {
    timeRange.setLength(model?.timeRange.length)
    timeRange.setTimeunit(model?.timeRange.value)
  }
  request.setTimerange(timeRange)
  const response = await getQueryResourcesListRequest(client, request)
  const obj = (response as QueryResourcesListResponse).toObject()
  return obj
}

function getQueryResourcesListRequest(client: RBFServiceClient, request: QueryResourcesListRequest) {
  return new Promise((resolve, reject) => {
    try {
      client.queryResourcesList(request, getToken(), function(err, data) {
        if (err) {
          console.error(err);
          reject(err)
          getErrorId(err.message)
        } else {
          resolve(data);
        }
      });
    } catch (e) {
      console.error(e)
      reject(e);
    }
  })
}

export async function addTag(item: any) {
  const client = new RBFServiceClient(clientHost)
  const request = new AddTagRequest()
  request.setResourceid(item.sheetId)
  request.setResourcetype(item.type)
  request.setTagsList(item.tags)
  const response = await addTagRequest(client, request)
  return response
}

function addTagRequest(client: RBFServiceClient, request: AddTagRequest) {
  return new Promise((resolve, reject) => {
    try {
      client.addTag(request, getToken(), function(err, data) {
        if (err) {
          console.error(err);
          reject(err)
          getErrorId(err.message)
        } else {
          resolve(data);
        }
      });
    } catch (e) {
      console.error(e)
      reject(e);
    }
  })
}



export async function uploadMetricData(item: any) {
  const client = new RBFServiceClient(clientHost)
  const request = new UploadDataRequest()
  const ossFile = new OSSFile()
  ossFile.setKey(item.ossKey)
  ossFile.setOriginname(item.fileName)
  ossFile.setSha1(item.ossKey)
  ossFile.setBucket(item.options.bucket)
  const ossSource = new OSSSource()
  ossSource.setEndpoint(item.options.endpoint.host)
  ossSource.setRegion(item.options.region)
  ossSource.setOsstype(0)
  ossFile.setOsssource(ossSource)
  request.setOssfile(ossFile)
  const map = request.getAnnotationsMap()
  map.set("title", item.title)
  map.set("desc", item.desc)
  const response = await uploadMetricDataRequest(client, request)
  const da = (response as UploadDataResponse).toObject()
  console.log("da = ", da)
  return da
}

function uploadMetricDataRequest(client: RBFServiceClient, request: UploadDataRequest) {
  return new Promise((resolve, reject) => {
    try {
      client.uploadData(request, getToken(), function(err, data) {
        if (err) {
          console.error(err);
          reject(err)
          getErrorId(err.message)
        } else {
          resolve(data);
        }
      });
    } catch (e) {
      console.error(e)
      reject(e);
    }
  })
}